//NOTE !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
//NOTE !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
//NOTE !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
//NOTE !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
//NOTE !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
//NOTE !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
//This is same privacy policy as the one in the app, but with with different formatting and style. to be used independently on the google play store.
import React from "react";
import { useNavigate } from "react-router-dom";
import appIcon from '../assets/CollectedAF_Icon.png';

const PrivacyPolicy = () => {
  const navigate = useNavigate();

  return (
    <div className="relative min-h-screen bg-LIGHT_GREY flex justify-center py-12 px-4">
      {/* Dotted Background Pattern */}
      <div 
        className="absolute inset-0 opacity-20"
        style={{
          backgroundImage: 'radial-gradient(circle, #999 1px, transparent 1px)',
          backgroundSize: '20px 20px'
        }}
      />

      {/* Top-Left Icon */}
      <div className="absolute top-8 left-8 z-20">
        <div className="bg-WHITE rounded-lg p-2 shadow-lg">
          <img 
            src={appIcon} 
            alt="CollectedAF Icon" 
            className="w-12 h-12"
          />
        </div>
      </div>

      {/* Back Button */}
      <button
        onClick={() => navigate('/')}
        className="absolute top-8 right-8 z-20 flex items-center gap-2 bg-WHITE hover:bg-ORANGE text-BLACK hover:text-WHITE px-6 py-3 rounded-full shadow-lg transition-all duration-200 font-medium"
      >
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
        </svg>
        Back to Home
      </button>

      <div className="relative z-10 max-w-4xl w-full bg-WHITE rounded-2xl shadow-2xl p-8 md:p-12 mt-20">
        <h1 className="text-4xl md:text-5xl font-bold text-center mb-8 text-BLACK">
          Privacy Policy
        </h1>

        <p className="text-sm text-DARK_GREY leading-relaxed mb-6">
          collectedAF LLC built the collectedAF app as a Free app. This SERVICE
          is provided by collectedAF LLC at no cost and is intended for use as
          is. This page is used to inform visitors regarding our policies with
          the collection, use, and disclosure of Personal Information if anyone
          decided to use our Service. If you choose to use our Service, then you
          agree to the collection and use of information in relation to this
          policy. The Personal Information that we collect is used for providing
          and improving the Service. We will not use or share your information
          with anyone except as described in this Privacy Policy. The terms used
          in this Privacy Policy have the same meanings as in our Terms and
          Conditions, which are accessible at collectedAF unless otherwise
          defined in this Privacy Policy.
        </p>

        {/* Data Collected */}
        <p className="text-base font-bold text-BLACK mb-3 mt-6">
          Data We Collect
        </p>
        <p className="text-sm text-DARK_GREY leading-relaxed mb-4">
          We collect the following types of information when you use our
          Service:
        </p>
        <ul className="text-sm text-DARK_GREY list-disc list-inside mb-4 ml-4">
          <li><strong>Account information:</strong> full name, email address, phone number, age, and gender, collected during registration to create and manage your account.</li>
          <li><strong>Profile and user-generated content:</strong> profile photos, images, and other content you upload to personalize your experience and interact with other users.</li>
          <li><strong>Location data:</strong> precise and approximate location, including background location, used to power proximity-based features such as displaying nearby users, updating collections based on location, and enabling location-based interactions. With your consent, your approximate location may be shared with other users within the app.</li>
          <li><strong>Device and log information:</strong> IP address, device name, operating system version, app configuration, and usage timestamps, collected automatically to diagnose errors, improve performance, and maintain the Service.</li>
          <li><strong>SMS and verification data:</strong> phone number used for two-factor authentication (2FA) and identity verification via one-time SMS passcodes.</li>
        </ul>
        <p className="text-sm text-DARK_GREY leading-relaxed mb-4">
          We do not collect health or medical data. The app does use
          third-party services that may collect information used to identify
          you.
        </p>
        <p className="text-sm text-DARK_GREY leading-relaxed mb-4">
          You can enable or disable access to location data at any time
          through your device settings. collectedAF may collect location data
          while the app is in the background to enable continuous
          proximity-based features, even when the app is closed or not in use.
          Users can control and manage location permissions at any time through
          their device settings.
        </p>

        {/* Data Usage */}
        <p className="text-base font-bold text-BLACK mb-3 mt-6">
          How We Use Your Data
        </p>
        <p className="text-sm text-DARK_GREY leading-relaxed mb-4">
          We use the information we collect for the following purposes:
        </p>
        <ul className="text-sm text-DARK_GREY list-disc list-inside mb-4 ml-4">
          <li>To create, authenticate, and manage your account</li>
          <li>To provide, operate, and improve the features of our Service</li>
          <li>To enable location-based features and social interactions between users</li>
          <li>To send one-time passcodes for secure login via SMS</li>
          <li>To diagnose technical issues, monitor performance, and analyze usage patterns</li>
          <li>To enforce our terms of service and protect user safety</li>
          <li>To comply with legal obligations</li>
        </ul>
        <p className="text-sm text-DARK_GREY leading-relaxed mb-4">
          We do not sell your personal information to third parties. We may
          share data with third-party service providers only as necessary to
          operate and improve our Service, and such providers are contractually
          obligated to protect your data and use it solely for the purposes we
          specify.
        </p>

        {/* Data Retention */}
        <p className="text-base font-bold text-BLACK mb-3 mt-6">
          Data Retention
        </p>
        <p className="text-sm text-DARK_GREY leading-relaxed mb-4">
          We retain your personal information, including account data, profile
          information, and location data, for as long as your
          account is active or as needed to provide you with our Service. If
          you choose to delete your account, we will delete or anonymize your
          personal data within 30 days, except where we are required to retain
          certain information to comply with legal obligations, resolve
          disputes, or enforce our agreements.
        </p>
        <p className="text-sm text-DARK_GREY leading-relaxed mb-4">
          Log data and analytics information may be retained for up to 12
          months for the purpose of improving our Service and diagnosing
          technical issues, after which it is automatically deleted or
          anonymized.
        </p>

        {/* Data Deletion */}
        <p className="text-base font-bold text-BLACK mb-3 mt-6">
          Data Deletion
        </p>
        <p className="text-sm text-DARK_GREY leading-relaxed mb-4">
          You have the right to request deletion of your personal data at any
          time. You can delete your account and all associated data directly
          through the app's account settings. Alternatively, you may submit a
          data deletion request by emailing us at{" "}
          <a href="mailto:support@collectedAF.com" className="text-ORANGE hover:underline">support@collectedAF.com</a>.
        </p>
        <p className="text-sm text-DARK_GREY leading-relaxed mb-4">
          Upon receiving a deletion request, we will delete or anonymize your
          personal data within 30 days, including your profile information,
          location history, and any other personally identifiable
          information. Some data may be retained in anonymized form for
          analytics purposes or as required by law. We will confirm the
          completion of your deletion request via email.
        </p>

        {/* Child Safety and Protection */}
        <p className="text-base font-bold text-BLACK mb-3 mt-6">
          Child Safety and Protection
        </p>
        <p className="text-sm text-DARK_GREY leading-relaxed mb-4">
          At collectedAF, we are committed to ensuring the safety and well-being of children and preventing any misuse of our platform. We strictly prohibit users from creating, uploading, or distributing content that facilitates the exploitation or abuse of children. This includes all child sexual abuse materials (CSAM). Any violation of this policy will result in immediate account termination and may lead to removal from Google Play.
        </p>
        <p className="text-sm text-DARK_GREY leading-relaxed mb-4">
          We prohibit the use of our app to endanger children. This includes but is not limited to promoting predatory behavior towards children, such as:
        </p>
        <ul className="text-sm text-DARK_GREY list-disc list-inside mb-4 ml-4">
          <li>Inappropriate interaction targeted at a child (for example, groping or caressing)</li>
          <li>Child grooming (for example, befriending a child online to facilitate, either online or offline, sexual contact and/or exchanging sexual imagery with that child)</li>
          <li>Sexualization of a minor (for example, imagery that depicts, encourages or promotes the sexual abuse of children or the portrayal of children in a manner that could result in the sexual exploitation of children)</li>
          <li>Sextortion (for example, threatening or blackmailing a child by using real or alleged access to a child's intimate images)</li>
          <li>Trafficking of a child (for example, advertising or solicitation of a child for commercial sexual exploitation)</li>
        </ul>
        <p className="text-sm text-DARK_GREY leading-relaxed mb-4">
          We actively monitor and enforce policies to detect and prevent such behavior through moderation tools, reporting mechanisms, and collaboration with law enforcement and organizations specializing in child protection. We will take appropriate action, which may include reporting to the National Center for Missing & Exploited Children (NCMEC), if we become aware of content with child sexual abuse materials.
        </p>
        <p className="text-sm text-DARK_GREY leading-relaxed mb-4">
          In addition, we do not allow content that appeals to children but contains adult themes, including but not limited to:
        </p>
        <ul className="text-sm text-DARK_GREY list-disc list-inside mb-4 ml-4">
          <li>Apps with excessive violence, blood, and gore</li>
          <li>Apps that depict or encourage harmful and dangerous activities</li>
          <li>Apps that promote negative body or self image, including those that depict for entertainment purposes plastic surgery, weight loss, and other cosmetic adjustments to a person's physical appearance</li>
        </ul>

        <p className="text-base font-bold text-BLACK mb-3 mt-6">
          Age-Segmented Experience
        </p>
        <p className="text-sm text-DARK_GREY leading-relaxed mb-4">
          collectedAF enforces strict age-based separation within the app. During registration, every user's age is verified and used to determine their experience tier. Minors (under 18) are placed in a controlled environment where they can only discover, interact with, and communicate with other verified minors. Adult users are completely invisible to minors and vice versa. This architectural separation is enforced at the platform level and cannot be bypassed by individual users.
        </p>
        <p className="text-sm text-DARK_GREY leading-relaxed mb-4">
          Key safeguards include: proximity discovery, collections, and all social features are filtered by age group; messaging and communication channels are restricted to same-age-group peers only; content visibility, profiles, and user cards are segmented so minors and adults never appear in each other's feeds; and age misrepresentation is a terminable offense that is actively monitored.
        </p>

        <p className="text-base font-bold text-BLACK mb-3 mt-6">
          Child Safety Standards Compliance
        </p>
        <p className="text-sm text-DARK_GREY leading-relaxed mb-4">
          As a social app, collectedAF complies with Google Play's Child Safety Standards policy. We certify that our app:
        </p>
        <ul className="text-sm text-DARK_GREY list-disc list-inside mb-4 ml-4">
          <li><strong>Has Published Standards:</strong> We explicitly prohibit Child Sexual Abuse and Exploitation (CSAE) in our publicly accessible terms of service, community guidelines, and this privacy policy</li>
          <li><strong>Provides In-App Reporting:</strong> We provide a mechanism within our app for users to submit feedback, concerns, or reports regarding inappropriate content or behavior</li>
          <li><strong>Addresses CSAM:</strong> We take appropriate action, including removing CSAM and reporting to authorities, after obtaining actual knowledge of it, in accordance with our published standards and relevant laws</li>
          <li><strong>Complies with Child Safety Laws:</strong> We comply with applicable child safety laws and regulations, including having a process in place to report confirmed CSAM to the National Center for Missing and Exploited Children or relevant regional authorities</li>
          <li><strong>Provides a Child Safety Point of Contact:</strong> We maintain a designated point of contact at{" "}
          <a href="mailto:support@collectedAF.com" className="text-ORANGE hover:underline">support@collectedAF.com</a>
          {" "}to receive notifications from Google Play about CSAE content and to coordinate enforcement and review procedures</li>
        </ul>
        <p className="text-sm text-DARK_GREY leading-relaxed mb-4">
          If you encounter any content or activity that appears to involve child endangerment, abuse, exploitation, or CSAE, please report it immediately by contacting us at{" "}
          <a href="mailto:support@collectedAF.com" className="text-ORANGE hover:underline">support@collectedAF.com</a>.
          Your report will be treated with the utmost urgency and confidentiality. If you believe a child is in danger of or has been subject to abuse, exploitation, or trafficking, please contact your local law enforcement immediately.
        </p>
        <p className="text-sm text-DARK_GREY leading-relaxed mb-4">
          We reserve the right to take immediate action against accounts or individuals found to be engaging in such activities, including but not limited to reporting to appropriate authorities, terminating access to our Service, and cooperating fully with law enforcement investigations.
        </p>

        <p className="text-sm text-DARK_GREY leading-relaxed mb-4">
          Link to the privacy policy of third-party service providers used by
          the app:
        </p>
        <a href={`https://policies.google.com/privacy`} className="block text-base font-bold text-ORANGE hover:text-LIGHT_ORANGE my-3">
          Google Play Services
        </a>
        <a href={`https://firebase.google.com/policies/analytics`} className="block text-base font-bold text-ORANGE hover:text-LIGHT_ORANGE my-3">
          Google Analytics for Firebase
        </a>
        <a href={`https://firebase.google.com/support/privacy/`} className="block text-base font-bold text-ORANGE hover:text-LIGHT_ORANGE my-3">
          Google Crashlytics
        </a>
        <a href={`https://www.facebook.com/about/privacy/update/printable`} className="block text-base font-bold text-ORANGE hover:text-LIGHT_ORANGE my-3">
          Meta
        </a>
        <a href={`https://expo.dev/privacy`} className="block text-base font-bold text-ORANGE hover:text-LIGHT_ORANGE my-3">
          Expo
        </a>

        <p className="text-base font-bold text-BLACK mb-3 mt-6">Log Data</p>
        <p className="text-sm text-DARK_GREY leading-relaxed mb-4">
          We want to inform you that whenever you use our Service, in a case of
          an error in the app we collect data and information (through
          third-party products) on your phone called Log Data. This Log Data may
          include information such as your device Internet Protocol (“IP”)
          address, device name, operating system version, the configuration of
          the app when utilizing our Service, the time and date of your use of
          the Service, and other statistics.
        </p>

        <p className="text-base font-bold text-BLACK mb-3 mt-6">Cookies</p>
        <p className="text-sm text-DARK_GREY leading-relaxed mb-4">
          Cookies are files with a small amount of data that are commonly used
          as anonymous unique identifiers. These are sent to your browser from
          the websites that you visit and are stored on your device's internal
          memory. This Service does not use these “cookies” explicitly. However,
          the app may use third-party code and libraries that use “cookies” to
          collect information and improve their services. You have the option to
          either accept or refuse these cookies and know when a cookie is being
          sent to your device. If you choose to refuse our cookies, you may not
          be able to use some portions of this Service.
        </p>

        <p className="text-base font-bold text-BLACK mb-3 mt-6">Service Providers</p>
        <p className="text-sm text-DARK_GREY leading-relaxed mb-4">
          We may employ third-party companies and individuals due to the
          following reasons:
        </p>
        <ul className="text-sm text-DARK_GREY list-disc list-inside mb-4">
          <li>To facilitate our Service;</li>
          <li>To provide the Service on our behalf;</li>
          <li>To perform Service-related services; or</li>
          <li>To assist us in analyzing how our Service is used.</li>
        </ul>
        <p className="text-sm text-DARK_GREY leading-relaxed mb-4">
          We want to inform users of this Service that these third parties have
          access to their Personal Information. The reason is to perform the
          tasks assigned to them on our behalf. However, they are obligated not
          to disclose or use the information for any other purpose.
        </p>

        <p className="text-base font-bold text-BLACK mb-3 mt-6">Security</p>
        <p className="text-sm text-DARK_GREY leading-relaxed mb-4">
          We value your trust in providing us your Personal Information, thus we
          are striving to use commercially acceptable means of protecting it.
          But remember that no method of transmission over the internet, or
          method of electronic storage is 100% secure and reliable, and we
          cannot guarantee its absolute security.
        </p>

        <p className="text-base font-bold text-BLACK mb-3 mt-6">Links to Other Sites</p>
        <p className="text-sm text-DARK_GREY leading-relaxed mb-4">
          This Service may contain links to other sites. If you click on a
          third-party link, you will be directed to that site. Note that these
          external sites are not operated by us. Therefore, we strongly advise
          you to review the Privacy Policy of these websites. We have no control
          over and assume no responsibility for the content, privacy policies,
          or practices of any third-party sites or services.
        </p>

        <p className="text-base font-bold text-BLACK mb-3 mt-6">SMS Messaging & 2FA Verification</p>
        <p className="text-sm text-DARK_GREY leading-relaxed mb-4">
          collectedAF uses SMS-based messaging for account security and identity
          verification purposes only. This includes two-factor authentication
          (2FA) to confirm user logins and safeguard user accounts.
        </p>
        <p className="text-sm text-DARK_GREY leading-relaxed mb-4">
          By signing up for our Service and providing your phone number, you
          consent to receiving one-time passcodes via SMS for secure login.
          These messages are automated, contain no promotional content, and are
          essential to the function of the app.
        </p>
        <p className="text-sm text-DARK_GREY leading-relaxed mb-4">
          Users can manage their phone number and opt-in status through account
          settings. For more information, contact us at{" "}
          <a href="mailto:support@collectedAF.com" className="text-ORANGE hover:underline">support@collectedAF.com</a>.
        </p>

        <p className="text-base font-bold text-BLACK mb-3 mt-6">Children's Privacy</p>
        <p className="text-sm text-DARK_GREY leading-relaxed mb-4">
          These Services do not address anyone under the age of 13. We do not
          knowingly collect personally identifiable information from children
          under 13 years of age. In the case we discover that a child under 13
          has provided us with personal information, we immediately delete this
          from our servers. If you are a parent or guardian and you are aware
          that your child has provided us with personal information, please
          contact us so that we will be able to do the necessary actions.
        </p>
        <p className="text-sm text-DARK_GREY leading-relaxed mb-4">
          collectedAF enforces strict age-based separation within the app. During
          registration, every user's age is verified and used to determine their
          experience tier. Minors (under 18) are placed in a controlled environment
          where they can only discover, interact with, and communicate with other
          verified minors. Adult users are completely invisible to minors and vice
          versa. This architectural separation is enforced at the platform level and
          cannot be bypassed by individual users.
        </p>
        <ul className="text-sm text-DARK_GREY list-disc list-inside mb-4 ml-4">
          <li>Proximity discovery, collections, and all social features are filtered by age group</li>
          <li>Messaging and communication channels are restricted to same-age-group peers only</li>
          <li>Content visibility, profiles, and user cards are segmented so minors and adults never appear in each other's feeds</li>
          <li>Age misrepresentation is a terminable offense and is actively monitored</li>
        </ul>

        <p className="text-base font-bold text-BLACK mb-3 mt-6">Changes to This Privacy Policy</p>
        <p className="text-sm text-DARK_GREY leading-relaxed mb-4">
          We may update our Privacy Policy from time to time. Thus, you are
          advised to review this page periodically for any changes. We will
          notify you of any changes by posting the new Privacy Policy on this
          page. This policy is effective as of 2026-03-11.
        </p>

        <p className="text-base font-bold text-BLACK mb-3 mt-6">Contact Us</p>
        <p className="text-sm text-DARK_GREY leading-relaxed mb-4">
          If you have any questions or suggestions about our Privacy Policy, do
          not hesitate to contact us at support@collectedAF.com.
        </p>

        <div className="border-t border-gray-200 pt-6 mt-4">
          <a
            href="/?view=childSafety"
            className="text-sm text-ORANGE hover:underline font-semibold"
          >
            View our Child Safety Standards &rarr;
          </a>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
